import React from "react";
import theLoanProcess from "../../PicesForPages/TheLoanProcess.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function TheLoanProcess() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={theLoanProcess}
          alt="tlpImage"
          className="background-video theLoanProcessImage"
        />
        <div className="purchasetopBox TheLoanProcessPageTopBox">
          {/* The existing Purchase span */}
          <span>The Loan Process</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">Pre-qualification</span>
            <span className="purchaseBottomLeftContent">
              Before the formal loan process begins, pre-qualification is the
              first step. The lender reviews your income and debt details to
              determine an estimated home affordability range.
            </span>
            <span className="purchaseBottomLeftContent">
              It is highly recommended to understand your home-buying budget
              before starting your property search. For those considering
              refinancing, pre-qualification helps determine whether refinancing
              is a financially beneficial option.
            </span>

            <span className="purchaseBottomLeftHeader">Application</span>
            <span className="purchaseBottomLeftContent">
              The loan process officially begins with the application, which
              takes place after selecting a property to purchase or deciding to
              refinance an existing mortgage. You complete a mortgage
              application for a specific loan program and submit all required
              documentation. At this stage, fees and down payment options are
              clearly outlined and discussed. Within three days, your loan
              officer provides a Good Faith Estimate (GFE) and a
              Truth-In-Lending Disclosure (TIL), giving a transparent overview
              of loan rates and projected costs.
            </span>

            <span className="purchaseBottomLeftHeader">
              Processing of your Estimated Loan
            </span>
            <span className="purchaseBottomLeftContent">
              The lender typically submits your application to an automated
              underwriting system to identify the documentation required for
              loan approval. In some cases, the application may be reviewed
              through manual underwriting.
            </span>
            <span className="purchaseBottomLeftContent">
              The lender’s processor carefully verifies your employment, debts,
              and payment history by analyzing credit reports and supporting
              documents. If any concerns such as late payments or judgments
              arise, the processor may request clarification from you. They also
              evaluate the appraisal and survey to identify any property-related
              issues that could impact approval, ensuring a complete and
              accurate file is prepared for the underwriter.
            </span>

            <span className="purchaseBottomLeftHeader">Underwriting</span>
            <span className="purchaseBottomLeftContent">
              The underwriter reviews the processor’s file to ensure it meets
              the lender’s guidelines and approval standards. If additional
              information is required, the loan is placed in “suspense,” and
              further documentation will be requested.
            </span>
            <span className="purchaseBottomLeftContent">
              Once approved, the lender issues a conditional commitment,
              coordinates title insurance, assists in clearing all conditions,
              and prepares for closing. These conditions may relate to credit,
              income, or property factors identified during the processing and
              underwriting stages.
            </span>

            <span className="purchaseBottomLeftHeader">Closing</span>
            <span className="purchaseBottomLeftContent">
              After all conditions are satisfied and final loan approval is
              granted, the closing process takes place. The lender transfers
              funds via cashier’s check, draft, or wire transfer to the closing
              agent, who then disburses the funds and completes the property
              title transfer. This final step completes the loan process,
              allowing you to successfully refinance or purchase your home under
              the agreed terms. The closing location varies by state and may
              take place at an attorney’s office, title or escrow company, or
              even in the comfort of your home.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default TheLoanProcess;
